import { Check, CheckCheck, AlertCircle, Clock } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type WhatsAppStatus = 'pending' | 'sent' | 'delivered' | 'read' | 'failed'

interface WhatsAppMessageStatusProps {
  status: WhatsAppStatus
  errorMessage?: string | null
  className?: string
}

export default function WhatsAppMessageStatus({
  status,
  errorMessage,
  className = '',
}: WhatsAppMessageStatusProps) {
  const getStatusContent = () => {
    switch (status) {
      case 'pending':
        return {
          icon: <Clock className={`w-3.5 h-3.5 text-gray-400 ${className}`} />,
          tooltip: 'Enviando...',
        }
      case 'sent':
        return {
          icon: <Check className={`w-3.5 h-3.5 text-gray-400 ${className}`} />,
          tooltip: 'Enviada',
        }
      case 'delivered':
        return {
          icon: <CheckCheck className={`w-3.5 h-3.5 text-gray-400 ${className}`} />,
          tooltip: 'Entregue',
        }
      case 'read':
        return {
          icon: <CheckCheck className={`w-3.5 h-3.5 text-blue-500 ${className}`} />,
          tooltip: 'Lida',
        }
      case 'failed':
        return {
          icon: <AlertCircle className={`w-3.5 h-3.5 text-red-500 ${className}`} />,
          tooltip: errorMessage || 'Falha ao enviar',
        }
      default:
        return {
          icon: null,
          tooltip: '',
        }
    }
  }

  const { icon, tooltip } = getStatusContent()

  if (!icon) return null

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex items-center">{icon}</span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs">
        <p>{tooltip}</p>
      </TooltipContent>
    </Tooltip>
  )
}
